<template>
  <div class="text-center">
    <v-btn
      v-if="itemSelected.length > 0"
      icon
      v-on:click.prevent="exportExcel()"
    >
      <v-icon>mdi-download</v-icon>
    </v-btn>
    <v-btn v-else disabled icon v-on:click.prevent="exportExcel()">
      <v-icon>mdi-download</v-icon>
    </v-btn>
  </div>
</template>

<script>
import * as XLSX from "xlsx";

export default {
  props: {
    itemSelected: {
      type: Array,
      required: true,
    },
    periodoSeleccionado: {
      type: Object,
      default: null,
    },
  },

  methods: {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    exportExcel() {
      const data = this.ordenesTransformados;
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, "Caja Chica - Vicente Valdés");

      const periodo = this.periodoSeleccionado?.value;
      const fileName = periodo
        ? `caja_chica_santiago_vv_${periodo}.xlsx`
        : `caja_chica_santiago_vv.xlsx`;

      XLSX.writeFile(wb, fileName);
    },
  },

  computed: {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    ordenesTransformados() {
      return this.itemSelected.map((item) => {
        return {
          ["N°"]: item.numero,
          ["Periodo"]: item.periodo ?? "",
          ["Fecha"]: item.fecha,
          ["Rut Proveedor"]: item.rutProveedor,
          ["Nombre Proveedor"]: item.nombreProveedor,
          ["Acción"]: item.accion,
          ["Ingresos"]: item.ingreso,
          ["Egresos"]: item.egreso,
          ["Documento"]: item.documento,
          ["Concepto"]: item.concepto,
          ["Descripcion"]: item.descripcion,
        };
      });
    },
  },
};
</script>